import * as React from 'react';
import { Component } from 'react';
import styles from '../../styles/flyouts/working_set_plans/WorkingSetPlansFlyout.scss';
import * as _ from 'lodash';
import { get } from 'lodash';
import CloseBigIcon from '../../assets/images/close-big-15x15.svg';
import classNames from 'classnames';
import Properties from './Properties';
import { connect } from 'react-redux';
import History from './History';
import Versions from './Versions';
import { setNotification } from '../../redux/actions/general/notification';
import { __, validateForm } from '../../core/utils';
import DeliveryIcon from '../../assets/images/delivery-15x15.svg';
import { withRouter } from 'react-router';
import Tooltip from '../../components/Tooltip';
import Files from './Files';
import { Element, ScrollLink, scrollSpy } from 'react-scroll';
import ArrowDownMiddleIcon from '../../assets/images/arrow-down-middle-15x15.svg';
import autobind from 'autobind-decorator';
import EditWorkingSetPlanToolbarForm from '../../forms/plans/EditWorkingSetPlanToolbarForm';
import {
  listWorkingSetPlans,
  removeNewPlanVersionUpload,
  updateWorkingSetPlan,
  uploadNewPlanVersion,
} from '../../redux/actions/table/working_set_plans';
import DownloadIcon from '../../assets/images/download-15x15.svg';
import FileUploadIcon from '../../assets/images/file-upload-32x32.svg';
import PlanChildIcon from '../../assets/images/plan-child.svg';
import PlanParentIcon from '../../assets/images/plan-parent.svg';
import PlanSingleIcon from '../../assets/images/plan-single.svg';

const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      setTableParams: (params) =>
        dispatch({
          type: 'table.working_set_plans/SET_TABLE_PARAMS',
          params,
        }),
    },
  };
};

@connect(null, mapDispatchToProps)
@withRouter
class WorkingSetPlansFlyout extends Component {
  constructor(props) {
    super(props);

    this.state = {
      active: 'properties',
      collapsed_tabs: [], //fix for scrollSpy not working on init
      highlighted_tab: null,
    };

    this.highlight_timeout = null;

    this.tabs = ['properties', 'versions', 'files', 'history'];

    this.tab_refs = [];

    this.fileInputRef = React.createRef();
  }

  componentDidMount() {
    scrollSpy.update();

    this.props.readAction();
  }

  @autobind
  _toggleCollapseTab(tab) {
    this.setState({
      collapsed_tabs: _.xor(this.state.collapsed_tabs, [tab]),
    });
  }

  @autobind
  _highlightSection(section) {
    this.setState({ highlighted_tab: section }, () => {
      if (this.highlight_timeout) clearTimeout(this.highlight_timeout);

      this.highlight_timeout = setTimeout(() => {
        this.setState({ highlighted_tab: null });
      }, 200);
    });
  }

  @autobind
  _toggleCollapseTabs() {
    if (_.size(this.state.collapsed_tabs) == _.size(this.tabs)) {
      this.setState({
        collapsed_tabs: [],
      });
    } else {
      this.setState({
        collapsed_tabs: this.tabs,
      });
    }

    this.refs.scroll.scrollTop = 0;
  }

  @autobind
  _handleSubmit(formData) {
    formData = {
      ...this.props.data,
      status: formData.status,
      type: formData.type,
    };

    if (_.includes(['single', 'parent'], formData.type)) {
      formData = {
        ...formData,
        template_id: null,
        template_cell_id: null,
      };
    }

    return validateForm(
      updateWorkingSetPlan(formData.id, _.omit(formData, ['id'])).then(() => {
        this.props.match.params.stage &&
          listWorkingSetPlans(this.props.match.params.stage);

        this.props.readAction(formData.id);

        setNotification(__('plans.working-set.notification.details-saved'));
      })
    );
  }

  @autobind
  _handleAddVersion(event) {
    const files = event.target.files;

    if (!_.isEmpty(files)) {
      if (_.first(files).size >= 104857600) {
        setNotification({
          text: __('plans.working-set.notification.upload-limit'),
          type: 'warning',
        });
      } else {
        setNotification(__('plans.working-set.notification.uploading'));

        validateForm(
          uploadNewPlanVersion(this.props.data.id, _.first(files)).then(() => {
            this.props.readAction(this.props.data.id);
            removeNewPlanVersionUpload(this.props.data.id);
          })
        ).catch(({ errors }) => {
          if (_.has(errors, 'code')) {
            if (errors.code === 1) {
              setNotification({
                type: 'warning',
                text: __(
                  'plans.working-set.notification.upload-one-page-error'
                ),
              });
            }

            if (errors.code === 2) {
              setNotification({
                type: 'warning',
                text: __(
                  'plans.working-set.notification.upload-page-dimensions-error'
                ),
              });
            }
          }

          removeNewPlanVersionUpload(this.props.data.id);
        });
      }
    }
  }

  render() {
    const { data, readAction } = this.props;

    const { collapsed_tabs, highlighted_tab } = this.state;

    const TabLink = ScrollLink((props) => (
      <span
        ref={(ref) => (this.tab_refs[props.target] = ref)}
        onClick={(e) => {
          this.setState({
            collapsed_tabs: _.reject(
              collapsed_tabs,
              (section) => section == props.target
            ),
          });

          this._highlightSection(props.target);

          props.onClick(e);
        }}
        className={props.className}
      >
        {props.children}
      </span>
    ));

    const Tab = (props) => (
      <TabLink
        target={props.target}
        activeClass={styles.active}
        to={props.target}
        spy={true}
        smooth={true}
        duration={500}
        container={this.refs.scroll}
      >
        {props.children}
      </TabLink>
    );

    const types = {
      single: {
        icon: <PlanSingleIcon className={styles.icon} />,
      },
      parent: {
        icon: <PlanParentIcon className={styles.icon} />,
      },
      child: {
        icon: <PlanChildIcon className={styles.icon} />,
      },
    };

    return (
      <div className={styles.preview}>
        <div className={styles.header}>
          <div className={styles.title}>
            {types[data?.type].icon}
            <span>
              {data.code && <strong>{data.code}: </strong>}
              {data.title}
            </span>
            <CloseBigIcon
              onClick={() =>
                setTimeout(() => {
                  this.props.actions.setTableParams({
                    clicked_row: undefined,
                  });
                }, 100)
              }
            />
          </div>
          <div className={styles.actions}>
            <div className={styles.actionWrapper}>
              <Tooltip
                text={__('plans.tooltip.icon.working-set.upload-version')}
              >
                <FileUploadIcon
                  className={styles.uploadIcon}
                  onClick={() => this.fileInputRef.current?.click()}
                />
              </Tooltip>

              <input
                type='file'
                ref={this.fileInputRef}
                style={{ display: 'none' }}
                accept='application/pdf'
                onChange={this._handleAddVersion}
              />
            </div>

            {!_.isEmpty(data.versions) && (
              <div className={styles.actionWrapper}>
                <Tooltip
                  text={__('plans.tooltip.icon.working-set.download-version')}
                >
                  <DownloadIcon
                    onClick={() => {
                      this.props.actions.setTableParams({
                        export_plan_annotations_wizard: true,
                      });
                    }}
                  />
                </Tooltip>
              </div>
            )}
            <div className={styles.actionWrapper}>
              {this.props.match.params.stage &&
                _.get(data, 'is_editor') &&
                _.get(data, 'status') == '1' && (
                  <Tooltip
                    text={__('plans.tooltip.icon.working-set.plan-deliver')}
                  >
                    <DeliveryIcon
                      onClick={() => {
                        if (get(data, 'delivery')) {
                          setNotification({
                            text: __(
                              'plans.working-set.notification.already-delivered'
                            ),
                            type: 'warning',
                          });
                        } else {
                          this.props.actions.setTableParams({
                            actioned_row: undefined,
                            wizard_active: true,
                            selected_plans: [get(data, 'id')],
                          });
                        }
                      }}
                    />
                  </Tooltip>
                )}
            </div>
          </div>
        </div>

        <div className={styles.toolbar}>
          <EditWorkingSetPlanToolbarForm
            data={data}
            onSubmit={this._handleSubmit}
            initialValues={{
              ..._.pick(data, ['id', 'status', 'type', 'has_same_identifiers']),
            }}
          />
        </div>

        <div className={styles.tabsWrapper}>
          <ArrowDownMiddleIcon
            className={classNames(
              styles.collapseAll,
              _.size(collapsed_tabs) == _.size(this.tabs) && styles.collapsed
            )}
            onClick={this._toggleCollapseTabs}
          />
          <div className={styles.tabs}>
            <Tab target='properties'>
              {__('plans.current-set.tab.properties')}
            </Tab>
            <Tab target='versions'>
              {__('plans.working-set.tab.versions')}{' '}
              {!_.isEmpty(data.versions) && ' (' + _.size(data.versions) + ')'}
            </Tab>
            <Tab target='files'>
              {__('plans.working-set.tab.files')}{' '}
              {!_.isEmpty(data.files) && ' (' + _.size(data.files) + ')'}
            </Tab>
            <Tab target='history'>
              {__('plans.working-set.tab.history')}{' '}
              {!_.isEmpty(data.history) && ' (' + _.size(data.history) + ')'}
            </Tab>
          </div>
        </div>
        <div className={styles.content} ref='scroll'>
          <Element
            name='properties'
            className={classNames(
              styles.section,
              highlighted_tab == 'properties' && styles.highlighted
            )}
          >
            <div
              className={styles.title}
              onClick={() => this._toggleCollapseTab('properties')}
            >
              <ArrowDownMiddleIcon
                className={classNames(
                  styles.collapse,
                  _.includes(collapsed_tabs, 'properties') && styles.collapsed
                )}
              />
              {__('plans.current-set.tab.properties')}
            </div>
            <Properties
              collapsed={_.includes(collapsed_tabs, 'properties')}
              data={data}
              readAction={readAction}
            />
          </Element>
          <Element
            name='versions'
            className={classNames(
              styles.section,
              highlighted_tab == 'versions' && styles.highlighted
            )}
          >
            <div
              className={styles.title}
              onClick={() => this._toggleCollapseTab('versions')}
            >
              <ArrowDownMiddleIcon
                className={classNames(
                  styles.collapse,
                  _.includes(collapsed_tabs, 'versions') && styles.collapsed
                )}
              />
              {__('plans.working-set.tab.versions')}
              {!_.isEmpty(data.versions) && ' (' + _.size(data.versions) + ')'}
            </div>
            <Versions
              collapsed={_.includes(collapsed_tabs, 'versions')}
              data={data}
              readAction={readAction}
            />
          </Element>
          <Element
            name='files'
            className={classNames(
              styles.section,
              highlighted_tab == 'files' && styles.highlighted
            )}
          >
            <div
              className={styles.title}
              onClick={() => this._toggleCollapseTab('files')}
            >
              <ArrowDownMiddleIcon
                className={classNames(
                  styles.collapse,
                  _.includes(collapsed_tabs, 'files') && styles.collapsed
                )}
              />
              {__('plans.working-set.tab.files')}
              {!_.isEmpty(data.files) && ' (' + _.size(data.files) + ')'}
            </div>
            <Files
              collapsed={_.includes(collapsed_tabs, 'files')}
              data={data}
              readAction={readAction}
            />
          </Element>
          <Element
            name='history'
            className={classNames(
              styles.section,
              highlighted_tab == 'history' && styles.highlighted
            )}
          >
            <div
              className={styles.title}
              onClick={() => this._toggleCollapseTab('history')}
            >
              <ArrowDownMiddleIcon
                className={classNames(
                  styles.collapse,
                  _.includes(collapsed_tabs, 'history') && styles.collapsed
                )}
              />
              {__('plans.working-set.tab.history')}
              {!_.isEmpty(data.history) && ' (' + _.size(data.history) + ')'}
            </div>
            <History
              collapsed={_.includes(collapsed_tabs, 'history')}
              data={data}
              readAction={readAction}
            />
          </Element>
        </div>
      </div>
    );
  }
}

export default WorkingSetPlansFlyout;
